import { DataItem } from 'scrivito'

import { Message } from '@/Data/Message/MessageDataClass'
import { WhoAmI } from '@/Data/WhoAmI/WhoAmIDataItem'
import { reportError } from '@/utils/reportError'

interface Args {
  subjectId: string
}

export const useMessageTabData = ({ subjectId }: Args) => {
  const loggedInUserId = (WhoAmI.get('contactId') as string) ?? ''

  let messages: DataItem[] = []
  let error: unknown

  try {
    if (subjectId) {
      messages = Message.all()
        .transform({
          filters: { subjectId },
          order: [['createdAt', 'asc']],
        })
        .take()
    }
  } catch (e) {
    reportError(e)
    error = e
  }

  return { messages, loggedInUserId, error }
}
